import React from 'react';
import './RoleBadge.css';

const ROLE_CONFIG = {
  'Vater': {
    color: '#3b82f6',
    icon: '[V]',
    label: 'Vater'
  },
  'Mutter': {
    color: '#ec4899',
    icon: '[M]',
    label: 'Mutter'
  },
  'Kind': {
    color: '#10b981',
    icon: '[K]',
    label: 'Kind'
  }
};

function RoleBadge({ role, size = 'medium' }) {
  const config = ROLE_CONFIG[role];

  if (!config) {
    return null;
  }

  return (
    <span
      className={`role-badge role-badge-${size}`}
      style={{
        backgroundColor: config.color + '20',
        borderColor: config.color,
        color: config.color
      }}
    >
      <span className="role-icon">{config.icon}</span>
      <span className="role-label">{config.label}</span>
    </span>
  );
}

export default RoleBadge;
